import { environment } from '@web-env/environment';

const getCrmBaseUrl = (): string => environment.siteServiceLink.replace(/\/[^/]*$/, '');

export const getCrmProductsUrl = (): string => `${getCrmBaseUrl()}/crm/products`;

export const getCrmPlansUrl = (): string => `${getCrmBaseUrl()}/crm/plans`;
